/**
 * Clay artwork per game (from the art packs under public/games/<dir>/): a cover, an icon square once
 * delivered, and a few props used to dress the audience screen. Shared by the game cards and the TV frame.
 */
export interface GameArt {
  icon?: string;
  cover: string;
  /** Decorative props (no text, no secrets) for the TV lobby. */
  props?: string[];
}

const pack = (dir: string, props: string[] = []): GameArt => ({
  icon: `/games/${dir}/icon.webp`,
  cover: `/games/${dir}/cover.webp`,
  props: props.map((p) => `/games/${dir}/${p}.webp`),
});

// One game per line (keeps merges of new games conflict-free).
export const ART: Partial<Record<string, GameArt>> = {
  'panic-button': pack('panic', ['button', 'choice-a', 'choice-b']),
  snapscramble: pack('snap', ['winner-frame']),
  'act-of-nonsense': pack('nonsense', ['double-act', 'impostor']),
  'battle-bots': pack('bots', ['chassis-bulwark', 'chassis-skirmisher', 'chassis-technician']),
  'orb-havoc': pack('orb', ['piece-bounce_bumper', 'piece-boost_ramp']),
  'lava-rising': pack('lava'),
  'mercenary-market': pack('market', ['gavel', 'brickjaw', 'twinbow']),
  'wave-command': pack('wave'),
  'meteor-mayhem': pack('meteor'),
  'boulder-bash': pack('boulder', ['piece-bumper', 'piece-ramp']),
  'pizza-heist': pack('pizza', ['whole', 'slice', 'grillmaster']),
  'recess-rumble': pack('recess', ['it-crown', 'whistle', 'mode-tag']),
  filibuster: pack('filibuster', ['podium', 'gavel', 'buzzer']),
  misquoted: pack('misquoted', ['popcorn', 'ticket', 'spotlight']),
  'initial-reaction': pack('initial-reaction', ['tile', 'hourglass', 'shocked']),
  'star-struck': pack('star-struck', ['star', 'megaphone', 'trophy']),
  objection: pack('objection', ['judge', 'exhibit']),
  dealbreakers: pack('dealbreakers', ['deal', 'nodeal', 'prize']),
  'double-agent': pack('double-agent', ['dossier', 'mask', 'pudding']),
  'the-alibi': pack('alibi', ['detective', 'evidence-bag', 'watch']),
  'conspiracy-club': pack('conspiracy', ['board', 'tinfoil', 'pin']),
  'terrible-advice': pack('advice', ['letter', 'stamp', 'sticky']),
  'plot-twist': pack('plot', ['clapper', 'twist-mask', 'llama']),
  'rotten-reviews': pack('reviews', ['storefront', 'star-full', 'coin']),
  'human-resources': pack('hr', ['briefcase', 'resume', 'stamp']),
  'grudge-gauntlet': pack('gauntlet', ['showdown', 'quickdraw', 'rival']),
  phonenanigans: pack('phonenanigans', ['battery', 'dog', 'trophy']),
};
